/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6ae1cfbe"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "F:\\php-project\\admin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"library/layouts/VabLayoutComprehensive/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ae1cfbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ae1cfbe', __exports__)) {
    api.reload('6ae1cfbe', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6ae1cfbe", () => {
    api.rerender('6ae1cfbe', render)
  })

}


export default __exports__